import {
  listSourceGDAs_DDAs,
  listSourceVariantAll_VDAs,
  listSourceAcademic,
  listSourceDiseaseAll,
  listSourceGeneALL,
  listSourceChemicalAll,
} from './tableHelpers';

const variantSourceButtons = ['VARIANTS', 'VDA'];
const diseasesSourceButtons = ['DISEASES'];
const genesSourceButtons = ['GENES'];
const gdaDDASourceButtons = ['GDA', 'DDA'];
const chemicalSourceButtons = ['CHEMICALS'];

const TABS_WITHOUT_CHEMICALS = ['GDA', 'DDA', 'VDA', 'DISEASES', 'GENES', 'VARIANTS'];
const TABS_COMMON = ['GDA', 'DDA', 'DISEASES', 'GENES'];
const ALL_TABS = [...TABS_WITHOUT_CHEMICALS, 'CHEMICALS'];

const SOURCE_TAB_RESTRICTIONS: Record<string, string[]> = {
  CHEMBL: ['GDA', 'DDA', 'DISEASES', 'CHEMICALS'],
  CLINGEN: TABS_WITHOUT_CHEMICALS,
  CLINVAR: TABS_WITHOUT_CHEMICALS,
  CLINPGX: [...TABS_WITHOUT_CHEMICALS, 'CHEMICALS'],
  FINNGEN: TABS_WITHOUT_CHEMICALS,
  UKBIOBANK: TABS_WITHOUT_CHEMICALS,
  TEXTMINING_MODELS: [...TABS_WITHOUT_CHEMICALS, 'CHEMICALS'],
  GENCC: ['GDA', 'DDA', 'DISEASES', 'GENES', 'VARIANTS'],
  GWASCAT: ['GDA', 'DDA', 'VDA', 'DISEASES', 'GENES', 'VARIANTS'],
  PHEWASCAT: ['GDA', 'DDA', 'VDA', 'DISEASES', 'GENES', 'VARIANTS'],
  HPO: TABS_COMMON,
  INFERRED: TABS_COMMON,
  MGD_MOUSE: TABS_COMMON,
  MGD_HUMAN: TABS_COMMON,
  RGD_RAT: TABS_COMMON,
  RGD_HUMAN: TABS_COMMON,
  PSYGENET: TABS_COMMON,
  ORPHANET: TABS_COMMON,
  MODELS: ['GDA', 'DDA', 'DISEASES', 'GENES', 'CHEMICALS'],
  BIOBANK: ['GDA', 'DDA', 'VDA', 'DISEASES', 'GENES', 'VARIANTS'],
  CLINICALTRIALS: ['GDA', 'DDA', 'DISEASES', 'GENES', 'CHEMICALS'],
  TEXTMINING_HUMAN: [...TABS_WITHOUT_CHEMICALS, 'CHEMICALS'],
  UNIPROT: TABS_WITHOUT_CHEMICALS,
};

export function getTabsForSource(source: string): string[] {
  if (!source || source === 'ALL' || source === 'CURATED') {
    return ALL_TABS;
  }

  return SOURCE_TAB_RESTRICTIONS[source] ?? ALL_TABS;
}

export function isSourceEnabledForTab(source, tab, restrictSources: string | false | null = null) {
  if (restrictSources === 'CURATED' && !isValidCuratedSource(source, tab)) {
    return false;
  }

  const allowedTabs = SOURCE_TAB_RESTRICTIONS[source];
  if (allowedTabs && !allowedTabs.includes(tab)) {
    return false;
  }

  return true;
}

export function isValidCuratedSource(source, tab) {
  if (variantSourceButtons.includes(tab)) {
    return listSourceVariantAll_VDAs.CURATED.includes(source);
  }
  if (diseasesSourceButtons.includes(tab)) {
    return listSourceDiseaseAll.CURATED.includes(source);
  }
  if (genesSourceButtons.includes(tab)) {
    return listSourceGeneALL.CURATED.includes(source);
  }
  if (gdaDDASourceButtons.includes(tab)) {
    return listSourceGDAs_DDAs.CURATED.includes(source);
  }
  if (chemicalSourceButtons.includes(tab)) {
    return listSourceChemicalAll.CURATED.includes(source);
  }
  return source === 'CURATED';
}

function cleanCuratedSources(sources, tab) {
  return sources;
}

export function getSourceList({ tab, restrictSources }) {
  if (restrictSources === 'CURATED') {
    if (variantSourceButtons.includes(tab)) {
      return { CURATED: listSourceVariantAll_VDAs.CURATED };
    }
    if (diseasesSourceButtons.includes(tab)) {
      return { CURATED: listSourceDiseaseAll.CURATED };
    }
    if (genesSourceButtons.includes(tab)) {
      return { CURATED: listSourceGeneALL.CURATED };
    }
    if (gdaDDASourceButtons.includes(tab)) {
      return { CURATED: listSourceGDAs_DDAs.CURATED };
    }
    return listSourceAcademic;
  }

  if (variantSourceButtons.includes(tab)) {
    const sourcesObj = { ...listSourceVariantAll_VDAs };
    if (sourcesObj.CURATED) {
      sourcesObj.CURATED = cleanCuratedSources(sourcesObj.CURATED, tab);
    }
    return sourcesObj;
  }
  if (diseasesSourceButtons.includes(tab)) {
    const sourcesObj = { ...listSourceDiseaseAll };
    if (sourcesObj.CURATED) {
      sourcesObj.CURATED = cleanCuratedSources(sourcesObj.CURATED, tab);
    }
    return sourcesObj;
  }
  if (genesSourceButtons.includes(tab)) {
    const sourcesObj = { ...listSourceGeneALL };
    if (sourcesObj.CURATED) {
      sourcesObj.CURATED = cleanCuratedSources(sourcesObj.CURATED, tab);
    }
    return sourcesObj;
  }
  if (gdaDDASourceButtons.includes(tab)) {
    const sourcesObj = { ...listSourceGDAs_DDAs };
    if (sourcesObj.CURATED) {
      sourcesObj.CURATED = cleanCuratedSources(sourcesObj.CURATED, tab);
    }
    return sourcesObj;
  }
  if (chemicalSourceButtons.includes(tab)) {
    const sourcesObj = { ...listSourceChemicalAll };
    if (sourcesObj.CURATED) {
      sourcesObj.CURATED = cleanCuratedSources(sourcesObj.CURATED, tab);
    }
    return sourcesObj;
  }
  return [];
}
